export const ADD_DATA = "ADD_DATA";

export const AddressData = (payload) => ({
  type: ADD_DATA,
  payload,
});
